import React, { Component } from 'react';
import CustomPaper from "../utils/CustomPaper";
import ErrorIcon from 'material-ui/svg-icons/alert/error'
export default class NoMatch extends Component {


    render(){
        return (
            <CustomPaper title={'Chemin inconnu'}>
                <div  style={{height:200, textAlign:'center'}}>
                    <ErrorIcon style={{color:'orange',height:200, width:200}}/>
                </div>
            </CustomPaper>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/shared/pages/NoMatch.js